/* eslint-disable @repo/internal/fs/filename-pattern-match */
import CreatableReactSelect from '@atlaskit/react-select/creatable';

import createSelect from './create-select';

const CreatableSelect = createSelect(CreatableReactSelect);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default CreatableSelect;
